/* __next_internal_client_entry_do_not_use__ PaymentPlan auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1699))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.083Z
 */ export var PaymentPlan = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M12 7.71425V5.14282",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12 16.2856V18.8571",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M9.42871 14.5715C9.42871 15.8572 10.5807 16.2858 12.0001 16.2858C13.4196 16.2858 14.5716 16.2858 14.5716 14.5715C14.5716 12.0001 9.42871 12.0001 9.42871 9.42864C9.42871 7.71436 10.5807 7.71436 12.0001 7.71436C13.4196 7.71436 14.5716 8.36407 14.5716 9.42864",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18.8572 15.4286L22.2857 14.5714L23.1429 18",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M22.2858 14.5714C21.5569 16.7492 20.1824 18.6536 18.3452 20.0315C16.5079 21.4095 14.2949 22.1957 12.0001 22.2857V22.2857C9.89044 22.2796 7.83329 21.6274 6.10558 20.4167C4.37786 19.206 3.06254 17.4951 2.33667 15.5143",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M5.14289 8.57143L1.71432 9.42857L0.857178 6",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M1.71436 9.42852C2.48006 7.27359 3.86429 5.39235 5.69383 4.0202C7.52336 2.64804 9.71694 1.84593 12.0001 1.71423V1.71423C14.1097 1.7203 16.1669 2.37257 17.8946 3.58323C19.6223 4.79388 20.9376 6.5048 21.6635 8.48566",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "PaymentPlan", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
